import 'intersection-observer';

import { $, $$ } from '@zimpa/dom';

const PROBE_CLASS = '.js-probe';

class Probe {
    public constructor(probe: HTMLElement) {
        const id = probe.getAttribute('data-target');
        const className = probe.getAttribute('data-className');

        if (id === null || className === null) {
            return;
        }
        const target = $(id);

        if (target === undefined) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries: IntersectionObserverEntry[]): void => {
                entries.forEach((entry: IntersectionObserverEntry): void => {
                    if (entry.isIntersecting) {
                        target.classList.remove(className);
                    } else {
                        target.classList.add(className);
                    }
                });
            },
        );
        observer.observe(probe);
    }
}

export function visibilityProbe(): void {
    $$(PROBE_CLASS).map(
        (element: HTMLElement): Probe => {
            return new Probe(element);
        },
    );
}
